import { Field } from 'src/models';
import { Box } from '@mui/material';
import { forceString } from 'src/utils/forceString';

export const Image = ({ field }: { field: Field }) => {
  const imageData = field.dataSource ? JSON.parse(forceString(field.dataSource)) : {};
  return (
    <>
      <Box
        component="img"
        src={imageData.src}
        width={imageData.width}
        height={imageData.height}
        // alt={field.label}
        sx={{
          width: imageData.width || '100%',
          height: imageData.height || 'auto',
          objectFit: 'contain',
        }}
      />
    </>
  );
};
